if (!customElements.get('ritual-picker')) {
  customElements.define(
    'ritual-picker',
    class RitualPicker extends HTMLElement {
      connectedCallback() {
        this.onChange = this.onChange.bind(this);
        this.addEventListener('change', this.onChange);
        this.updateAtcPrice();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      onChange(event) {
        if (event.target.matches('input[name="quantity"]')) {
          this.updateAtcPrice();
        }
      }

      updateAtcPrice() {
        const checked = this.querySelector('input[name="quantity"]:checked');
        if (!checked?.dataset.atcPrice) return;

        const formId = checked.getAttribute('form');
        if (!formId) return;

        const priceEl = document
          .getElementById(formId)
          ?.closest('product-form')
          ?.querySelector('.product-form__submit-price');

        if (priceEl) priceEl.textContent = checked.dataset.atcPrice;
      }
    }
  );
}
